import script from "./HelpdeskLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpdeskLayout.vue?vue&type=script&setup=true&lang=js"

import "./HelpdeskLayout.vue?vue&type=style&index=0&id=5ee3ab31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee3ab31"]])

export default __exports__